import React from "react";
import {promptValue} from "lib/utils";
import "./DeviceAction.css";
import Button from "react-bootstrap/Button";

function DeviceAction({bond, action, path}) {
    function sendAction() {
        let actionValue = null;

        if (/^Set.+Limit$/.exec(action)) {
            actionValue = null;
        } else if (/^(Set|Increase|Decrease)/.exec(action)) {
            actionValue = promptValue(action, 1);
            if (!actionValue) return;
        }

        bond.action(path, actionValue).then((response) => {
        });
    }

    return (
        <Button
            variant={"outline-success"}
            key={path + action}
            value={action}
            onClick={sendAction}
        >
            {action}
        </Button>
    );
}

export default DeviceAction;
